/* global $ */
/* eslint no-unused-vars: 0 */

// control the secondary mobile menu buttons at bottom of screen - show/hide on scroll

const secondaryNav = document.querySelector('.secondary-mobile-menu');

let prevScrollpos = window.pageYOffset;
window.onscroll = function () {
	const currentScrollPos = window.pageYOffset;
	if (prevScrollpos > currentScrollPos) {
		secondaryNav.style.transform = 'translateY(0)';
	} else {
		secondaryNav.style.transform = 'translateY(100%)';
	}
	prevScrollpos = currentScrollPos;
};
